import { css } from 'styled-components';

export const printMixins = {
  hide: css`
    @media print {
      display: none;
    }
  `,
  border: css`
    @media print {
      border: 1px solid ${({ theme }) => theme.color.border.primary};
    }
  `,
  avoidPageBreak: css`
    @media print {
      break-inside: avoid;
    }
  `,
};
